import { render } from "./Loading.vue?vue&type=template&id=3c61ea36"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/dialog/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c61ea36"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c61ea36', __exports__)) {
    api.reload('3c61ea36', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=3c61ea36", () => {
    api.rerender('3c61ea36', render)
  })

}


export default __exports__